
var template = require('./index.html')
var locales = require('./locales.json')
var t = require('../translate')


module.exports = {
  props: ['products'],
  created: function() {
    var config = require('app-config');
    //console.log(config)    
    this.home_url = config.home_url;
    this.server_url = config.server_url;
  },
  template: template,
  data: data,
  computed: {
    orderedProducts: function()
    {
      return this.products.sort(function(a,b){return a.featured < b.featured })
    }
  },
  methods: {
    aligned: function (product, alignment, index) {
      var i = alignment + index

      if (product.featured) {
        return false
      } else {
        return (i + 1) % 2 ? false : true
      }
    },
    getURL: function(p) {
      return this.home_url+"/"+p;
    }
  }
}

function data () {
  return {
    "server_url": "",
    "title": t(locales, 'title'),

    "button": {
      visit: t(locales, 'button.visit'),
      buy: t(locales, 'button.buy')
    }
  }
}


// WEBPACK FOOTER //
// ./lib/showcase/index.js